import { render, staticRenderFns } from "./app-cookie.vue?vue&type=template&id=0b0089a0&scoped=true&"
import script from "./app-cookie.vue?vue&type=script&lang=js&"
export * from "./app-cookie.vue?vue&type=script&lang=js&"
import style0 from "./app-cookie.vue?vue&type=style&index=0&id=0b0089a0&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0089a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0b0089a0', component.options)
    } else {
      api.reload('0b0089a0', component.options)
    }
    module.hot.accept("./app-cookie.vue?vue&type=template&id=0b0089a0&scoped=true&", function () {
      api.rerender('0b0089a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/app-cookie.vue"
export default component.exports